import { render } from "./SelectMulti.vue?vue&type=template&id=2d2712e8"
import script from "./SelectMulti.vue?vue&type=script&lang=ts"
export * from "./SelectMulti.vue?vue&type=script&lang=ts"
script.render = render

export default script